/**
 * Pull a download filename out of a Content-Disposition header, falling back to
 * the supplied name when the header is absent or has no filename. An RFC 5987
 * `filename*` value (percent-encoded, charset-prefixed) takes precedence over a
 * plain `filename` and is URI-decoded.
 */
const parseContentDispositionFilename = (
    header: string | null | undefined,
    fallback: string,
): string => {
    if (!header) {
        return fallback;
    }

    const extendedMatch = header.match(/filename\*=(?:[^']*'[^']*')?([^;]+)/i);
    if (extendedMatch && extendedMatch[1]) {
        try {
            return decodeURIComponent(extendedMatch[1].trim().replace(/^"|"$/g, ''));
        } catch {
            // fall through to plain filename / fallback on malformed encoding
        }
    }

    const plainMatch = header.match(/filename=("?)([^";]+)\1/i);
    if (plainMatch && plainMatch[2]) {
        return plainMatch[2].trim();
    }

    return fallback;
};

export default parseContentDispositionFilename;
